"use client";

import type {
  BaseKeyFunction,
  UseOpenApiInfiniteQueryOptions,
} from "@packages/sdk";
import {
  useOpenApiInfiniteQuery,
  useOpenApiMutation,
  useQueryClient,
} from "@packages/sdk";

type UseRequestNotificationsProps = Omit<
  UseOpenApiInfiniteQueryOptions<"/notifications">,
  "urlBackendPath" | "queryKey" | "initialPageParam" | "getNextPageParam"
>;

export const keyNotifications: BaseKeyFunction<
  UseRequestNotificationsProps["params"]["query"]
> = (props) => ["notifications", props?.page_size ?? 25] as const;

export const useRequestNotifications = (
  props: UseRequestNotificationsProps = {},
) => {
  const queryClient = useQueryClient();
  return {
    infiniteQuery: useOpenApiInfiniteQuery({
      urlBackendPath: "/notifications",
      queryKey: keyNotifications(props?.params?.query ?? {}),
      initialPageParam: null as number | null,
      getNextPageParam: (lastPage) =>
        lastPage?.length ? lastPage[lastPage.length - 1].id : undefined,
      ...props,
    }),
    mutationMarkAllRead: useOpenApiMutation({
      method: "PUT",
      urlBackendPath: "/notifications/read",
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["notifications"] });
      },
    }),
    mutationMarkRead: useOpenApiMutation({
      method: "PUT",
      urlBackendPath: "/notifications/{id}/read",
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["notifications"] });
      },
    }),
  };
};
